import axios from "axios";

export default axios.create({
    baseURL: 'https://message-lab-333c3.firebaseio.com/'
})
